import { useMemo } from "react";
import Konva from "konva";
import { VirtualElement } from "@floating-ui/react";

/**
 * Creates a virtual element from a Konva node for use with Floating UI.
 * Transforms canvas coordinates to viewport coordinates accounting for stage scale and position.
 */
export function useKonvaVirtualElement(konvaNode: Konva.Node | null, stage: Konva.Stage | null): VirtualElement {
  return useMemo<VirtualElement>(
    () => ({
      getBoundingClientRect: () => {
        if (!konvaNode || !stage) {
          return { x: 0, y: 0, top: 0, left: 0, bottom: 0, right: 0, width: 0, height: 0 };
        }

        const stageScale = stage.scaleX(); // Assuming uniform scale
        const nodeRect = konvaNode.getClientRect();

        // Transform canvas coordinates to viewport coordinates
        // Formula: viewportPos = stageContainerPos + (canvasPos * scale + stageOffset)
        const left = nodeRect.x;
        const top = nodeRect.y;
        const width = nodeRect.width / stageScale;
        const height = nodeRect.height / stageScale;

        return { x: left, y: top, top, left, bottom: top + height, right: left + width, width, height };
      },
    }),
    [konvaNode, stage]
  );
}
